import { ruby } from '~/utils/core/factories';

const store = {
  ...ruby('providers[mv]'),
};

const useStore = () =>
  store;

export {
  store,
  useStore,
};
